import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { PaymentRefundComponent } from '../payment-refund/payment-refund.component';
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { FlashMessagesService } from "angular2-flash-messages";
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-invoices-list',
  templateUrl: './invoices-list.component.html',
  styleUrls: ['./invoices-list.component.css']
})
export class InvoicesListComponent implements OnInit {
  public idform: any;
  public showForm = false;
  public showClient = false;
  public loading = false;
  public invoiceList: Array<any> = [];
  public invoiceOptions: any = {};
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public limit = 100;
  public search: string = "";
  public sortColumnName = "invoice_id";
  public sortDirection = "desc";
  public filterText: string;
  public userData: any = {};
  navigationSubscription;
  public invoiceType = "";
  public loginRedirectUrl = environment.Old_Client_URL;
  public isPublicQuoteCreation = false;
  constructor(private CommonService: CommonService,
    private router: Router,
    private activateroute: ActivatedRoute,
    public dialog: MatDialog,
    private _flashMessagesService: FlashMessagesService,
    private CommonProjectDataService: CommonProjectDataService
  ) {
    // override the route reuse strategy
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.navigationSubscription = this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
    var routerVerifier = this.router.url.split("/");
    routerVerifier.includes("builder") ? localStorage.setItem("isPublicQuoteCreation", "Yes") : localStorage.setItem("isPublicQuoteCreation", "No");
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
  }

  ngOnInit() {
    this.CommonService.removeProjectTitleStorage();
    localStorage.removeItem('backgroundOrderId');
    localStorage.removeItem('emailSentHistory');
    if (this.activateroute.snapshot.params["id"] || this.activateroute.snapshot.params["invoiceID"]) {
      let invoiceID = (this.activateroute.snapshot.params["id"]) ? this.activateroute.snapshot.params["id"] : this.activateroute.snapshot.params["invoiceID"];
      this.formView(this.showForm, invoiceID, 'quote');
    }
    else {
      localStorage.removeItem('storeId');
      this.getInvoiceList();
      this.userData = JSON.parse(localStorage.getItem('userDetails'));
    }
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  getInvoiceList = function () {
    this.loading = true;
    this.invoiceOptions = {
      id: localStorage.getItem("userID"),
      limit: this.limit,
      page: this.page,
      type: 'Invoice'
    };

    if (this.filterText) {
      this.invoiceOptions.search = this.filterText;
    }

    if (this.sortDirection) {
      this.invoiceOptions.orderBy = this.sortColumnName;
      this.invoiceOptions.direction = this.sortDirection;
    }

    this.CommonService.apiService(
      "POST",
      "orders",
      this.invoiceOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.invoiceList = response.data.records;
            this.total = response.data.total;
            this.current_page = response.data.current_page;
            this.limit = response.data.limit;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }
  toggleForm(loading) {
    if (loading == true) {
      this.getInvoiceList();
    }
    this.idform = null;
    this.showForm = !loading;
  }
  formView(loading, id, status) {
    this.CommonService.removeProjectTitleStorage();
    localStorage.removeItem('backgroundOrderId');
    localStorage.removeItem('emailSentHistory');
    if (loading == true) {
      this.getInvoiceList();
    }
    this.idform = id;
    if (this.activateroute.snapshot.params["type"]) {
      this.invoiceType = this.activateroute.snapshot.params["type"];
    }
    this.showForm = !loading;
    if (this.router.url == '/invoices' || this.router.url.split(';')[0] == '/invoices' || this.router.url.split(';')[0] == '/builder/invoices') {
      if (this.isPublicQuoteCreation == true) {
        this.router.navigate(["/builder/invoices/" + this.idform]);
      }
      else {
        this.router.navigate(["/invoices/" + this.idform]);
      }
    }

  }
  goToPage(n: number): void {
    this.page = n;
    this.getInvoiceList();
  }

  onNext(): void {
    this.page++;
    this.getInvoiceList();
  }

  onPrev(): void {
    this.page--;
    this.getInvoiceList();
  }
  goSort($event) {
    this.sortColumnName = $event.columnName;
    this.sortDirection = $event.sortDirection;
    this.getInvoiceList();
  }
  filterType(): void {
    this.page = 1;
    this.total = 0;
    this.getInvoiceList();
  }
  clearFilter(): void {
    this.filterText = "";
    this.page = 1;
    this.total = 0;
    this.getInvoiceList();
  }

  viewClient(userId) {
    if (this.userData.type != 'Printer' && this.userData.type != 'Designer') {
      this.router.navigate(['/clients/listing', { id: userId }]);
    }
  }
  duplicateInvoice(id) {
    localStorage.removeItem('resumeOrder');
    localStorage.removeItem('resumeOrderType');
    this.router.navigate(['/quote', { id: id, type: 'Duplicate' }]);
  }

  openPaymentRefundDialog(invoiceId, payAmount, refundedAmount): void {
    const dialogRef = this.dialog.open(PaymentRefundComponent, {
      width: "500px",
      disableClose: true,
      data: {
        user_id: localStorage.getItem("userID"),
        invoice_id: invoiceId,
        pay_Amount: payAmount,
        refunded_Amount: refundedAmount
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.getInvoiceList();
      }
    });
  }

  openDeleteDialog(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Are you sure you want to delete this invoice",
        manageData: { quote_id: id }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.quote_id) {
        this.deleteQuote(result.quote_id);
      }
    });
  }

  deleteQuote = function (invoice_id) {
    this.clientOptions = {};
    this.CommonService.apiService(
      "DELETE",
      "order/" + localStorage.getItem("userID") + "/" + invoice_id,
      this.clientOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show("invoice deleted successfully!", {
            cssClass: "alert-success",
            timeout: 5000
          });
          this.getInvoiceList();
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  };

  getOrderList = function (id) {
    this.loading = true;
    this.invoiceOptions = {
      id: localStorage.getItem("userID"),
      order_id: id
    };
    let apiMethod: string;
    apiMethod = "order"
    this.CommonService.apiService(
      "POST",
      apiMethod,
      this.invoiceOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            let obj = JSON.parse(JSON.stringify(response));
            this.projects = obj.data;
            this.CommonProjectDataService.store(this.projects);
            if (this.isPublicQuoteCreation == true) {
              this.router.navigate(["/builder/invoices/order"]);
            }
            else {
              this.router.navigate(["/invoices/order"]);
            }
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  clickToGo(pathUrl) {
    if (pathUrl == 'dashboard' || pathUrl == 'po/orders') {
      this.loading = true;
      this.router.navigate([pathUrl]);
    }
  }

  cloneOrder(orderId) {
    this.loading = true;
    const payLoad = {
      id: localStorage.getItem("userID"),
      order_id: orderId
    }
    this.CommonService.cloneOrder(payLoad).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 5000
          });

          if (response.data.orderId) {
            this.router.navigate(["/quote/" + response.data.orderId]);
          }
        }
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  } 

  openInvoiceDeleteDialog(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Deleting this invoice will refund any payments made by you or your customer. Would you like to proceed?",
        manageData: { invoice_id: id, isNewDialog: true }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.invoice_id) {
        this.deletewithRefundInvoice(result.invoice_id);
      }
    });
  }

  deletewithRefundInvoice = function (invoice_id) {
    this.options = {
      id: localStorage.getItem("userID"),
      invoice_id: invoice_id
    };
    this.CommonService.apiService(
      "POST",
      "invoice/refund-and-delete",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 5000
          });

          this.getInvoiceList();
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  };

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/invoices-list/invoices-list.component.ts